<template>
	<div>
		<div class="card panel panel-default actions">
		    <div class="card-block">
		        <h4>Effective Sell Prices</h4>
		        <div v-if="channels.length > 0" class="price-breakdown-container clearfix" :class="{ open: loaded_channel.channel_id != null  }">
		            <div class="price-listing">
		                <ul>
		                	<li v-for="channel in channels" :class="{selected: loaded_channel.channel_id == channel.channel_id}">
		                		<div class="channel-name">{{channel.name}}</div>
								<transition name="channel-names">
									<div v-if="loaded_channel.channel_id == null" class="costs-container clearfix">
										<div class="cost"><span class="cost-label">Sell:</span>	 <span v-if="channel.sell_price > 0">{{channel.sell_price}}</span><span v-else>N/A</span></div>
										<div class="cost"><span class="cost-label">Cost:</span>	 <span v-if="channel.cost > 0">{{channel.cost}}</span><span v-else>N/A</span></div>
										<div class="cost"><span class="cost-label">MSRP:</span>	 <span v-if="channel.msrp > 0">{{channel.msrp}}</span><span v-else>N/A</span></div>
										<div class="cost"><span class="cost-label">MAP:</span>	 <span v-if="channel.map > 0">{{channel.map}}</span><span v-else>N/A</span></div>
									</div>
									<div v-else class="costs-container costs-container-open  clearfix">
										<div class="channel-open-column">
											<div class="cost"><span class="cost-label">Sell:</span>	 <span v-if="channel.sell_price > 0">{{channel.sell_price}}</span><span v-else>N/A</span></div>
											<div class="cost"><span class="cost-label">Cost:</span>	 <span v-if="channel.cost > 0">{{channel.cost}}</span><span v-else>N/A</span></div>
										</div>
										<div class="channel-open-column">
											<div class="cost"><span class="cost-label">MSRP:</span>	 <span v-if="channel.msrp > 0">{{channel.msrp}}</span><span v-else>N/A</span></div>
											<div class="cost"><span class="cost-label">MAP:</span>	 <span v-if="channel.map > 0">{{channel.map}}</span><span v-else>N/A</span></div>
										</div>
									</div>
								</transition>
								<div v-if="channel.priceRuleSets" class="action-button">
									<transition name="actions-button">
										<button v-if="loaded_channel.channel_id != channel.channel_id" v-on:click="togglePanel(channel)" class="reveal-breakdown btn btn-primary">
												Details
										</button>
										<button v-else v-on:click="closePanel()" class="reveal-breakdown btn btn-primary">
												Close
										</button>
									</transition>
								</div>
		                	</li>
		                </ul>
		            </div>
		            <div class="breakdown-listing">
		                <div v-if="loaded_channel.priceRuleSets != null" class="dataTables_wrapper container-fluid dt-bootstrap4">
	                        <table class="table table-minified table-striped  table-middle">
	                            <thead>
	                                <tr>
	                                	<th width="35"></th>
	                                    <th>Set Name</th>
	                                    <th>Rule Name</th>
	                                    <th>Calculation</th>
	                                    <th>From</th>
	                                    <th>To</th>
	                                    <th>Value</th>
	                                </tr>
	                            </thead>
	                            <tbody v-for="sets in loaded_channel.priceRuleSets">
	                            	<tr v-if="sets.type == 'calculation'"  v-for="(rule, key, index) in sets.calculation.rulesApplied">
	                            		<td class="text-center">
	                            			<span  v-if="index == 0">
	                            				<i class="fa fa-calculator" aria-hidden="true"></i>
	                            			</span>
	                            		</td>
	                            		<td>
	                            			<a v-if="index == 0" :href="'/price-rule-engine/sets/'+ sets.id"> {{sets.name}}</a>
	                            		</td>
	                            		<td><a :href="'/price-rule-engine/sets/'+sets.id+'/rules/'+rule.id">{{rule.name}}</a></td>
	                            		<td>{{rule.calculation}}</td>
	                            		<td>{{rule.calculatePriceFrom.replace(/[_-]/g, " ")}}</td>
	                            		<td>{{rule.priceToCalculate.replace(/[_-]/g, " ")}}</td>
	                            		<td v-html="setColorOfValue(rule.value)"></td>
	                            	</tr>
	                            	<tr v-if="sets.type == 'guard'"  v-for="(rule, key, index) in sets.guard.rulesApplied">
	                            		<td class="text-center">
	                            			<span  v-if="index == 0">
	                            				<i class="fa fa-shield" aria-hidden="true"></i>
	                            			</span>
	                            		</td>
	                            		<td>
	                            			<a v-if="index == 0" :href="'/price-rule-engine/sets/'+ sets.id"> {{sets.name}}</a>
	                            		</td>
	                            		<td><a :href="'/price-rule-engine/sets/'+sets.id+'/rules/'+rule.id">{{rule.name}}</a></td>
	                            		<td>{{rule.calculation}}</td>
	                            		<td>{{rule.calculatePriceFrom}}</td>
	                            		<td>{{rule.priceToCalculate}}</td>
	                            		<td v-html="setColorOfValue(rule.value)"></td>
	                            	</tr>
	                            </tbody>
	                        </table>
	                    </div>
	                </div>
	            </div>
	            <div v-else>
	            	<div class="alert alert-danger ks-solid-light ks-active-border" role="alert">
	            		No Channels Found
	            	</div>
	            </div>
	        </div>
	    </div>
	</div>
</template>

<style scoped="" lang="scss">
	.actions-button-enter-active, .actions-button-leave-active {
	  transition: opacity .5s;
	}
	.actions-button-enter, .actions-button-leave-to {
	  opacity: 0;
	}

	.channel-names-enter-active, .channel-names-leave-active {
	  transition: opacity .5s;
	}
	.channel-names-enter, .channel-names-leave-to {
	  opacity: 0;
	}
	.card-block h4{
		margin-bottom: 15px;
	}
	.table-minified{
		margin-bottom:0;
		position: relative;
		tr{
			th{
				border-top: 0;
			}
			td, th{
				padding: 7px 12px 6px 12px !important;
				border-right: 1px solid #dee0e1;
				&:last-child{
					border-right: 0;
				}
			}
		}
		tbody{
			border-bottom: 1px solid #dee0e1;
		}
	}
	.price-breakdown-container{
		border: 1px solid #dee0e1;
		overflow:hidden;
		transition: all 0.7s;
		min-height: 57px;
		.price-listing{
			transition: all 0.5s;
			min-height: 57px;
			float: left;
			width: 100%;
			ul{
				padding-left:0;
				list-style-type:none;
				margin-bottom: 0px;
				li{
					position: relative;
					padding: 10px 10px;
					border-bottom: 1px solid #dee0e1;
					&:last-child{
						border-bottom: 0;
					}
					&.selected {
						transition: background-color 0.5s;
					    background-color: #f5f6fa;
					}
				}
			}
			.channel-name{
				font-size: 11px;
			    color: #25628f;
			    font-weight: 700;
			}
			.costs-container{
				.cost{
					transition: all 0.5s;
					margin-right: 15px;
					margin-top: 1px;
					float: left;
					margin-right:10px;
				}
				.cost-label{
					color: #8a8a8a;
				}
				.clearfix{
					width: 40%;
					float: left;
				}
				&.costs-container-open{
					.cost{
						float: none;
					}
					.channel-open-column{
						width: 40%;
						float: left;
					}
				}
			}
			.action-button{
				transition: top linear 0.2s;
				position: absolute;
				top: 10px;
				right: 10px;
				.btn-primary{
					padding: 9px 10px 10px 10px;
					height: 35px;
					border:0;
				}
			}
		}
		.breakdown-listing{
			transition: all 0.5s;
			min-height: 57px;
			float: left;
			overflow-y:scroll;
			overflow-x:hidden;
			width: 0%;
		}
		&.open{
			transition: all 0.5s;
			min-height:280px;
			.costs-container{
				.cost{
					transition: all 0.5s;
					margin-right: 5px;
				}
			}
			.action-button{
				transition: top linear 0.2s;
				top: 20px;
			}
			.price-listing{
				position: relative;
				z-index: 2;
				transition: all 0.5s;
				min-height:280px;
				width: 30%;
				border-right: 1px solid #dee0e1;
				box-shadow: -1px 0px 5px 0px rgba(0,0,0,0.15);
			}
			.breakdown-listing{
				transition: all 0.5s;
				min-height:280px;
				width: 70%;
			}
		}
	}
</style>

<script type="text/javascript">
	import Vue from 'vue';
	import VueEvents from 'vue-events'
	import select2 from 'select2';

	Vue.use(VueEvents);

	export default {
	    name: 'effective-sell-price',
	    props: ['PriceRuleAdjusted'],
	    components:{
	    },
	    data() {
	    	return {
	    		uiStates: {
	    			panelOpen:false,
	    		},
	    		channels: this.PriceRuleAdjusted,
	    		loaded_channel: {
	    			channel_id: null,
	    			priceRuleSets: null,
	    		}
			}
	    },
	    methods: {
	        togglePanel (channel) {
	        	var listingHeight = $('.price-listing').height();
	        	$('.breakdown-listing').css('height', listingHeight+'px');
	        	$('.price-breakdown-container').css('height', listingHeight+'px');

	        	this.loaded_channel.channel_id = channel.channel_id;
	        	this.loaded_channel.priceRuleSets = channel.priceRuleSets;
            },
            closePanel () {
	        	this.loaded_channel.channel_id = null;
	        	this.loaded_channel.priceRuleSets = null;
            },
            setColorOfValue (value) {
              	if (value > 0) {
              	    return '<span style="color:#4caf50;">'+value+'</span>';
              	}
              	if (value < 0) {
              	 	return '<span style="color:#ef5350;">'+value+'</span>';
              	}
              	return '<span>'+value+'</span>';
            },
	    },
	};
</script>
